import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-code-input',
  templateUrl: './code-input.component.html',
  styleUrls: ['./code-input.component.scss'],
})
export class CodeInputComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  code: string[] = new Array(6).fill('');

  timeLeft: number = 600;

  timer: any;

  display: string = '';

  @ViewChildren('inputBox') inputBoxes!: QueryList<ElementRef>;

  @Output() codeChanged = new EventEmitter<string>();

  @Output() resendCode = new EventEmitter<void>();
  @Input() recipient: string;
  @Input() minutesLeft = 10;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.focusInput(0);

    // 🔧 Defer to avoid ExpressionChangedAfterItHasBeenCheckedError
    // setTimeout(() => {
    //   this.startCountdown();
    // });
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('minutesLeft' in changes) {
      this.timeLeft = this.minutesLeft * 60;
      this.startCountdown();
    }
  }

  startCountdown() {
    this.updateDisplay(); // Initial display
    this.timer = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.updateDisplay();
      } else {
        clearInterval(this.timer);
        this.display = '00:00';
      }
    }, 1000);
  }

  updateDisplay() {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    this.display = `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  onResend() {
    this.resendCode.emit();
    this.startCountdown();
  }

  handleInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '').charAt(0); // only one digit

    if (value) {
      this.code[index] = value;
      input.value = value; // enforce value (for safety)

      // focus next box
      setTimeout(() => {
        if (index < this.code.length - 1) {
          this.focusInput(index + 1);
        }
      });
    } else {
      this.code[index] = '';
    }

    // TO-DO: CHECK lenght detection n backpress
    this.codeChanged.emit(this.code.join(''));
  }

  handleKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace') {
      this.code[index] = '';
      if (!input.value && index > 0) {
        this.focusInput(index - 1);
      }
    }
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '').slice(0, 6).split('');

    this.code = Array(6).fill('');
    this.inputBoxes.forEach((input, i) => {
      input.nativeElement.value = '';
      if (digits[i]) {
        this.code[i] = digits[i];
        input.nativeElement.value = digits[i];
      }
    });

    this.focusInput(Math.min(digits.length, 5));
  }

  focusInput(index: number) {
    const input = this.inputBoxes.get(index)?.nativeElement;
    if (input) {
      input.focus();
      setTimeout(() => input.setSelectionRange(1, 1), 0);
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
